module.exports = "/images/AC.png?a8a87ac531458e13be093b7a7f0364cb";